import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from "./header";
import { auctionDeliveryHealth_template } from "../components/templates/auctionDeliveryHealth_template";
import { getListResultsElement, startListLoading, stopListLoading, } from "~/utils/listLoading";
export class auctionDeliveryHealth extends vnModule_knockoutJS {
    constructor() {
        super(...arguments);
        this.listRequestGeneration = 0;
    }
    getModuleName() {
        return "auction_delivery_health";
    }
    cleanup() {
        this.tpl?.destroyDatePickerCalendar?.();
    }
    internalLoad(container) {
        this.build();
        this.insertIn(container);
        for (const element of this.content) {
            try {
                ko.applyBindings(this.viewModel, element);
            }
            catch (error) {
                console.error("Knockout binding failed for", element.id, error);
            }
        }
        this.loadSavedViewModule();
        try {
            this.fillPage();
        }
        finally {
            container.classList.remove("loading");
        }
    }
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle("Auction Delivery Health");
        loadedModule.setBreadcrumbs([
            { label: "Home", href: "/home", icon: "home" },
            { label: "Auction Delivery Health", href: null },
        ]);
        this.tpl = new auctionDeliveryHealth_template("auctionDeliveryHealth_template", this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    fillPage() {
        try {
            this.tpl.buildDatePickerCalendar();
            this.getListFormData();
        }
        catch (error) {
            console.error(error);
            this.stopListLoading();
        }
    }
    getListResultsElement() {
        return getListResultsElement(this.tpl?.builtTemplate);
    }
    startListLoading() {
        startListLoading(this, this.tpl?.builtTemplate);
    }
    stopListLoading() {
        stopListLoading(this, this.tpl?.builtTemplate);
    }
    getListFormData() {
        this.startListLoading();
        this.requestHandler = new XMLHttpRequestHandler("/api/auctionDeliveryHealth/references/", [], this);
        this.requestHandler.onReadyStateFunction = this.onFilterRequestReturn;
        this.requestHandler.execute();
    }
    onFilterRequestReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }
            try {
                obj.manageResponse(req, obj, function () {
                    if (req.request.status !== 200) {
                        return;
                    }
                    try {
                        const responseParsed = JSON.parse(req.request.response || "{}");
                        obj.updateFilters(responseParsed);
                        obj.updateViewModelFromPath();
                        obj.getData();
                    }
                    catch (error) {
                        console.error(error);
                        obj.stopListLoading();
                    }
                });
            }
            catch (error) {
                console.error(error);
                obj.stopListLoading();
            }
            finally {
                if (req.request.status !== 200) {
                    obj.stopListLoading();
                }
            }
        };
    }
    updateFilters(responseParsed) {
        this.tpl.setBrandFilterItems(responseParsed?.brands);
        this.tpl.setProductFilterItems(responseParsed?.products);
        this.tpl.setBidTypeFilterItems(responseParsed?.bidTypes);
    }
    getData() {
        const generation = ++this.listRequestGeneration;
        this.startListLoading();
        try {
            const subViewModel = this.tpl.getViewModelForRequest();
            const baseApiUrl = "/api/auctionDeliveryHealth/get/";
            this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn(generation), XMLHttpRequestHandler_requestType.GET, "getData");
        }
        catch (error) {
            console.error(error);
            this.stopListLoading();
        }
    }
    onDataRequestReturn(generation) {
        return (req, obj) => {
            return function () {
                if (req.request.readyState !== 4) {
                    return;
                }
                try {
                    obj.manageResponse(req, obj, function () {
                        if (req.request.status !== 200) {
                            return;
                        }
                        const responseParsed = JSON.parse(req.request.response || "{}");
                        obj.tpl.setStatus(responseParsed?.status);
                        obj.tpl.setListData(responseParsed?.listData ?? []);
                        if (responseParsed?.filters) {
                            obj.tpl.setPartnerFilterItems(responseParsed.filters.partners);
                            obj.tpl.setCarrierFilterItems(responseParsed.filters.carriers);
                        }
                    });
                }
                catch (error) {
                    console.error(error);
                }
                finally {
                    if (generation === obj.listRequestGeneration) {
                        obj.stopListLoading();
                    }
                }
            };
        };
    }
    filterDropdownOnChange() {
        this.getData();
    }
    filterMultipleSelectorOnChange(_elem) {
        this.getData();
    }
    listReorder() {
        this.getData();
    }
    filterDateOnChange() {
        this.getData();
    }
}
